import React from "react";
import AdminSidebar from "../../../components/AdminSidebar";
import WhiteStockList from "../Devices/WhiteStockList";
const WhiteStockReport = () => {
  return (
    <AdminSidebar>
      <WhiteStockList />
    </AdminSidebar>
  );
};

export default WhiteStockReport;
